import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

export interface IWrapperProps {
  className?: string;
  children: React.ReactNode | React.ReactNode[];
  ref?: React.Ref<HTMLDivElement>;
}

export function Wrapper({ className, children, ref }: IWrapperProps) {
  return (
    <div ref={ref} className={cx(styles['container'], className)}>
      {children}
    </div>
  );
}
